import { Button, Group, Table } from "@mantine/core";
import { useTranslation } from "react-i18next";

import type { RewardDraft } from "@/features/referral/lib/referral-schemas";
import { ActiveBadge } from "@/shared/ui/active-badge";

export type RewardRow = {
	id: string;
	reward: string;
	pointsCost: number;
	isActive: boolean;
	redemptionCount: number;
};

export function RewardsTable({
	rows,
	onEdit,
	onDelete,
}: {
	rows: RewardRow[];
	onEdit: (draft: RewardDraft) => void;
	onDelete: (row: RewardRow) => void;
}) {
	const { t } = useTranslation();
	return (
		<Table.ScrollContainer type="native" minWidth={640}>
			<Table verticalSpacing="sm">
				<Table.Thead>
					<Table.Tr>
						<Table.Th>{t("referral.item")}</Table.Th>
						<Table.Th>{t("referral.pointsCost")}</Table.Th>
						<Table.Th miw={120}>{t("common.status")}</Table.Th>
						<Table.Th>{t("referral.redemptions")}</Table.Th>
						<Table.Th />
					</Table.Tr>
				</Table.Thead>
				<Table.Tbody>
					{rows.map((row) => (
						<Table.Tr key={row.id}>
							<Table.Td>{row.reward}</Table.Td>
							<Table.Td>{row.pointsCost}</Table.Td>
							<Table.Td miw={120} style={{ whiteSpace: "nowrap" }}>
								<ActiveBadge active={row.isActive} />
							</Table.Td>
							<Table.Td>{row.redemptionCount}</Table.Td>
							<Table.Td>
								<Group gap="xs" justify="flex-end" wrap="nowrap">
									<Button
										size="xs"
										variant="light"
										onClick={() =>
											onEdit({
												id: row.id,
												reward: row.reward,
												pointsCost: row.pointsCost,
												isActive: row.isActive,
											})
										}
									>
										{t("common.edit")}
									</Button>
									<Button
										size="xs"
										color="red"
										variant="subtle"
										onClick={() => onDelete(row)}
									>
										{t("common.delete")}
									</Button>
								</Group>
							</Table.Td>
						</Table.Tr>
					))}
				</Table.Tbody>
			</Table>
		</Table.ScrollContainer>
	);
}
